import { create } from 'zustand';
import type { CurrencyType } from '../models/booking.model.ts';
import { useServiceStore } from './service.store.ts';

const CURRENCY_KEY = 'korehalal_currency';
const DEFAULT_CURRENCY: CurrencyType = 'KRW';

export const CURRENCIES: CurrencyType[] = ['KRW', 'USD', 'SGD', 'MYR', 'IDR', 'BND', 'EUR', 'GBP'];

type CurrencyState = {
  currency: CurrencyType;
  setCurrency: (c: CurrencyType) => void;
  hydrateFromStorage: () => void;
};

export const useCurrencyStore = create<CurrencyState>((set, get) => ({
  currency: DEFAULT_CURRENCY,

  setCurrency: (c) => {
    const changed = get().currency !== c;
    set({ currency: c });
    localStorage.setItem(CURRENCY_KEY, c);
    // 금액이 담긴 서비스 캐시는 이전 통화 응답이다 — 비워야 재조회가 실린다.
    if (changed) useServiceStore.getState().clearPricedCaches();
  },

  hydrateFromStorage: () => {
    const raw = localStorage.getItem(CURRENCY_KEY) as CurrencyType | null;
    if (raw) set({ currency: raw });
  },
}));
